module.exports = __webpack_public_path__ + "static/media/double-standard-img6.101054cd.jpg";